import type { ComponentPropsWithoutRef } from "react";
import prLogoUrl from "../../assets/bj/pr.png";

type PrLogoProps = ComponentPropsWithoutRef<"img"> & { mask?: boolean };

export function PrLogo({ className, mask = false, alt = "", ...props }: PrLogoProps) {
  if (!mask) return <img src={prLogoUrl} alt={alt} className={className} {...props} />;

  return (
    <span
      className={`inline-block size-8  ${className}`}
      {...props}
      style={{
        maskImage: `url(${prLogoUrl})`,
        WebkitMaskImage: `url(${prLogoUrl})`,
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskSize: "contain",
        WebkitMaskSize: "contain",
        maskPosition: "center",
        WebkitMaskPosition: "center",
      }}
    />
  );
}
